import Vector from './Vector'

/**
 * Grid class
 *      - Helper class that categorizes objects into tiles to make location based lookup easier
 */
export default class {
    constructor (width, height, tileSize = 50) {
        this._width = width
        this._height = height
        this._tileSize = tileSize
        this._tiles = []
        this._objects = []
    }

    add (object) {
        let tile = this._getTile(object.getLocation())
        tile.objects[ object.getId() ] = object

        return this
    }

    update (object) {
        this.remove(object)
            .add(object)

        return this
    }

    remove (object) {
        let oldTile = this._tiles.find(tile => !!tile.objects[ object.getId() ])
        if (oldTile) {
            delete oldTile.objects[ object.getId() ]
        }

        return this
    }

    findInBox (box) {
        const hashes = this._getHashesForBox(box)

        return this._getTilesContent(hashes)
    }

    _getTile (vector) {
        const hash = this._hashLocation(vector)
        if (!this._tiles[ hash ]) {
            this._tiles[ hash ] = {
                objects: [],
                hash,
            }
        }
        return this._tiles[ hash ]
    }

    _hashLocation (vector) {
        return Math.floor(vector.getX() / this._tileSize) * this._tileSize + '_' +
            Math.floor(vector.getY() / this._tileSize) * this._tileSize
    }

    _getHashesForBox (box) {
        const hashes = []

        box.x1 = Math.floor(box.x1 / this._tileSize) * this._tileSize
        box.x2 = Math.floor(box.x2 / this._tileSize) * this._tileSize
        box.y1 = Math.floor(box.y1 / this._tileSize) * this._tileSize
        box.y2 = Math.floor(box.y2 / this._tileSize) * this._tileSize

        for (let cX = box.x1; cX <= box.x2; cX += this._tileSize) {
            for (let cY = box.y1; cY <= box.y2; cY += this._tileSize) {
                hashes.push(
                    this._hashLocation(new Vector(cX, cY)),
                )
            }
        }
        return hashes
    }

    _getTilesContent (hashes) {
        let objects = []

        hashes.forEach((hash) => {
            objects = objects.concat(this._getTileContent(hash))
        })

        return objects.filter((key, index, array) => {
            return array.indexOf(key) === index
        })
    }

    _getTileContent (hash) {
        return this._tiles[ hash ] ? Object.values(this._tiles[ hash ].objects) : []
    }
}
